module.exports = __webpack_public_path__ + "media/images/front/sp/institution-search/top_key_visual-612aa80b958820d964ce97e2133bbf39.png";